/* Template: Modal
 ========================================================================== */

/**
 * Var object with modal open / close helper functions, so they can be
 * referenced easily within this module.
 */
var modalService = {
	open: function(modal, focusOpen, focusClose, touchmove) {
		if (touchmove) {
			/* Mobile menu - needs touch move */
			$(modal).fadeIn('fast').attr('aria-hidden', 'false');
			/* Adds class - Disable scroll on body */
			document.body.classList.add('mobile-menu-active');
		} else {
			$(modal).fadeIn('fast').attr('aria-hidden', 'false').on('touchmove', function(e) {
				e.preventDefault();
				e.stopPropagation();
				return false;
			});
		}

		$(focusOpen).focus();
		$.trapKeyboard(modal);

		$(document).on('keyup', function(e) {
			if (e.keyCode === 27) {
				modalService.close(modal, focusClose);

				/* Removes class - Enable scroll on body */
				document.body.classList.remove('mobile-menu-active');
			}
		});
	},
	close: function(modal, focusClose) {
		$(modal).fadeOut('fast').attr('aria-hidden', 'true').off('touchmove');

		/* Removes class - Enable scroll on body */
		document.body.classList.remove('mobile-menu-active');

		$.untrapKeyboard();
		$(focusClose).focus();

		$(document).off('keyup');
	}
};